<template>
  <div>
    <!-- <v-card-title class="modal-cadastro-titulo">
       {{ item. }}
    </v-card-title> -->
    <!-- <div class="modal-extrato-credito-titulo-total"></div> -->

    <v-card-text class="modal-cadastro-form">
      <v-skeleton-loader
        :loading="loadingTable"
        :transition="'fade-transition'"
        height="350px"
        type="table">
          <v-data-table
            :headers="headers"
            :items="listExtratoJogos"
            :items-per-page.sync="itensPerPage"
            flat
            dense
            show-expand
            single-expand
            hide-default-footer
          >
            <template v-slot:top>
              <v-toolbar 
                flat 
                color="white"
                class="toolbar"
              >
                <FiltroRangeDate @input="filtrar" :value="rangeDate" />              
              </v-toolbar>
            </template>

            <template v-slot:item.transmissions?.jsonFlags?.isGameBonusWeb="{ item }">
              <span>{{ item.transmissions?.jsonFlags?.isGameBonusWeb ? 'Bônus': 'Crédito'}}</span>
            </template>

            <template v-slot:item.value="{ item }">
              <span :style="`color: ${getColor(item.entryType ? item.entryType.type : null)};`">
                {{ item.value | currency }}
              </span>
            </template>

            <template v-slot:item.winners="{ item }">
              <span v-if="item.winners[0]">{{ item.winners[0].pendingOperations.value | currency  }}</span>
              <span v-else>-</span>
            </template>

            <template v-slot:item.deleted="{ item }">
              <v-chip color="red" outlined class="text-white" v-if="item.deleted !== '1970-01-01T03:00:00.000Z' "> Estornado </v-chip>
              <v-chip color="green" outlined class="text-white" v-else >Ok</v-chip>
            </template>

            <template v-slot:item.icon="{ item }">
              <span  v-if="item.winners[0]" style="display: flex; justify-content: center; align-items: center; width: 100%;">
                <img src="@/assets/img/icon-premio.png" alt="Logo" class="logo" style="width: 20px;"/>
              </span>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <div class="box-table-palpites">
                  <v-data-table
                    :headers="headersSubTable"
                    :items="item.headers[0].guess"
                    hide-default-footer
                    dense
                    :items-per-page="item.headers[0].guess.length"
                  >
                    <template v-slot:item.guess="{item}">
                      {{ getPalpitesFormatado(item) }}
                    </template>

                    <template v-slot:item.value="{item}">
                      {{ item.value | currency }}
                    </template>

                    <template v-slot:item.prize="{item}">
                      <span v-if="getValorPremioPorPalpite(item)">{{ getValorPremioPorPalpite(item) | currency }}</span>
                      <span v-else>-</span>
                      
                    </template>

                    <template v-slot:item.icon="{item}">
                      <span  v-if="getPlapitePremiado(item)" style="display: flex; justify-content: center; align-items: center; width: 100%;">
                        <img src="@/assets/img/icon-premio.png" alt="Logo" class="logo" style="width: 20px;"/>
                      </span>
                    </template>
                  </v-data-table>
                </div>
              </td>
            </template>

            <template v-slot:footer>
                <div class="py-2">
                  Total Créditos: {{ totalValue() | currency }}
                </div>
                <div class="">
                  Total Bonus: {{ totalValue(true) | currency }}
                </div>
              <div class="d-flex align-center justify-space-between">
                <div class="qtd-paginacao">
                  {{ pageStart }}
                  -
                  {{ pageStop }}
                  de
                  {{ totalExtratoJogos }}
                </div>
                <v-pagination
                  v-model="page"
                  :length="numberOfPages"
                  circle
                  :disabled="loadingTable"
                  :total-visible="10"
                  class="box-table-paginacao"
                  v-if="numberOfPages > 1"></v-pagination>
              </div>
            </template>
          </v-data-table>
        </v-skeleton-loader>
      </v-card-text>
    </div>
</template>

<script>
import variables from '@/assets/styles/helpers/_variables.scss'
import { mapGetters } from 'vuex'
import moment from 'moment'
import listagemTables from './listagemTables'

export default {
  name: 'UsuariowebExtratoJogos',
  mixins: [listagemTables],
  components: {
    FiltroRangeDate: () => import('@/views/components/filtroRangeDate')
  },
  data: () => ({
    headers: [
      { align: 'start', class: 'table-header', text: 'Loteria', value: 'sweepstakes.cod' },
      { align: 'start', class: 'table-header', text: 'Data Transmissão', value: 'createdFull' },
      { align: 'start', class: 'table-header', text: 'Data Aposta', value: 'sweepstakes.dtDrawFormat' },
      { align: 'start', class: 'table-header', text: 'Modalidade', value: 'headers[0].modalities.name' },
      { align: 'start', class: 'table-header', text: 'Prêmio', value: 'prizeRange[0]' },
      { align: 'start', class: 'table-header', text: 'Tipo', value: 'transmissions?.jsonFlags?.isGameBonusWeb' },
      { align: 'start', class: 'table-header', text: 'Valor', value: 'value' },
      { align: 'start', class: 'table-header', text: 'Valor Prêmio', value: 'winners' },
      { align: 'center', class: 'table-header', text: 'Status', value: 'deleted' },
      { align: 'start', class: 'table-header', text: '', value: 'icon' }
    ],
    headersSubTable: [
      { sortable: false, class: 'table-header', text: 'Palpites', value: 'guess' },
      { sortable: false, class: 'table-header', text: 'Valor', value: 'value' },
      { sortable: false, class: 'table-header', text: 'Valor Prêmio', value: 'prize' },
      { sortable: false, class: 'table-header', text: '', value: 'icon' },
    ],
    rangeDate: {
      start: moment().add(-7, 'days').format('YYYY-MM-DD'),
      end: moment().format('YYYY-MM-DD')
    },
    itensPerPage: 50,
    page: 1,
  }),
  
  computed: {
    ...mapGetters('usuariosWeb', {item: 'item', listExtratoJogos: 'listExtratoJogos', loadingTable: 'loadingTable', totalExtratoJogos: 'totalExtratoJogos'}),
    variables: () => variables,
  },

  mounted () {
    this.$emit('updatedRangeDate', this.rangeDate)
  },

  methods: {
    init () {},
    clearItens () {},

    getColor (type) {
      switch (type) {
        case 'D':
          return this.variables.colorError
        case 'C':
          return this.variables.colorSecondary
      }
    },
    totalValue (bonus) {
      let self = this
      if (bonus){
        return self.listExtratoJogos.reduce((acc, item)=> (item.transmissions?.jsonFlags?.isGameBonusWeb ? parseFloat(item.value): 0) + acc, 0)
      } 
      return self.listExtratoJogos.reduce((acc, item)=> (!item.transmissions?.jsonFlags?.isGameBonusWeb ? parseFloat(item.value): 0) + acc, 0)
      
    },

    formatarData () {
      const self = this
      self. dateFormatted = moment(self.date).format('DD/MM/YYYY')
    },
    filtrar (e) {
      if (e.start !== '' && e.end !== '') {
        this.rangeDate = {
          start: e.start,
          end: e.end
        }
        this.$emit('obterJogosPorData', this.rangeDate, this.page)
      }
    },

    getPalpitesFormatado (item) {
      const jogos = this.listExtratoJogos.find(it => it.palpites.find(palpite => palpite.id === item.id))
      const palpites = jogos.palpites.find(it => it.id === item.id)
      return palpites ? palpites.palpite : []
    },

    getPlapitePremiado (item) {
      return !!this.listExtratoJogos.find(it => it.winners.find(winner => winner.lotteryGuessId === item.id))
    },

    getValorPremioPorPalpite (item) {
      const winner = this.listExtratoJogos.find(it => it.winners.find(winner => winner.lotteryGuessId === item.id))
      const prize = winner ? winner.winners.find(it => it.lotteryGuessId === item.id) : null
      return prize ? prize.prizeValue : null
    }
  }
}
</script>

<style lang="scss" src="@/assets/styles/view/usuarios-web.scss">
</style>